import { render, staticRenderFns } from "./Series.vue?vue&type=template&id=b5dc096c&scoped=true"
import script from "./Series.vue?vue&type=script&lang=js"
export * from "./Series.vue?vue&type=script&lang=js"
import style0 from "./Series.vue?vue&type=style&index=0&id=b5dc096c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dc096c",
  null
  
)

export default component.exports